import { render } from "./SidebarItem.vue?vue&type=template&id=52ff6102&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"

import "./SidebarItem.vue?vue&type=style&index=0&id=52ff6102&scoped=true&lang=css"

import exportComponent from "/builds/mobilemediaru/cashforapp/cashforapp_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52ff6102"]])

export default __exports__